import { PlayCircleFilled, StopFilled } from "@ant-design/icons";

import { RVIcon, RVIconSizeOptions, RVIconVariantOptions, getColor } from "@regal-voice/ui";

import styles from "./AgentIcon.module.scss";

export function AgentIcon({ available }: { available: boolean }): JSX.Element {
    return (
        <div className={styles.iconWrapper}>
            <RVIcon
                icon="headset"
                color="light-purple"
                size={RVIconSizeOptions.LARGE}
                variant={RVIconVariantOptions.LARGE_CIRCLE}
                bgColor="purple-1"
            />
            <div className={styles.availableStatus}>
                {available ? (
                    <PlayCircleFilled style={{ color: getColor("green3") }} />
                ) : (
                    <StopFilled style={{ color: getColor("gray3") }} />
                )}
            </div>
        </div>
    );
}
